import { Spinner } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { Button } from "newui/components/Button";
import Tooltip from "newui/components/Tooltip";
import { useRfxIndividualResponseExport } from "newui/features/RfxReports";
import { ResponsePdfDownloadButtonProps } from "./types";

export const ResponsePdfDownloadButton = ({
	isLoading,
	rfxId,
	submissionId,
}: ResponsePdfDownloadButtonProps) => {
	const { mutate: downloadResponse, isPending: isPdfLoading } = useRfxIndividualResponseExport();

	const downloadResponsePdf = () => {
		downloadResponse({ rfxId, inviteId: submissionId });
	};
	return (
		<Tooltip
			label={
				"Download a PDF version of your submission to see how it will look"
			}
		>
			<Button
				type="button"
				btntype="secondary"
				disabled={isPdfLoading || isLoading}
				onClick={downloadResponsePdf}
				data-testid="pdf-response-button"
				className="!text-xs"
			>
				<Icon
					icon="download"
					className="pr-2"
				/>
				{isPdfLoading && <Spinner className="mr-2" />}
				{isPdfLoading ? "Generating, please wait..." : "Download Response PDF"}
			</Button>
		</Tooltip>
	);
};
